import script from "./SortOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortOption.vue?vue&type=script&setup=true&lang=ts"

import "./SortOption.vue?vue&type=style&index=0&id=97c1dcd6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97c1dcd6"]])

export default __exports__